module.exports = __webpack_public_path__ + "static/media/200512-artwork-fashion-slashie-nassia.7cbe3f94.jpg";